import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';

interface iSortStatus {
  label: string,
  status: number
}

@Component({
  selector: 'as-thead',
  templateUrl: './thead.component.html',
  styleUrls: ['./thead.component.scss']
})

export class TheadComponent implements OnInit {
  @Output() onChange = new EventEmitter();
  @Output() selectAllonPage = new EventEmitter();
  @Input() headers;
  @Input() data;
  @Input() ajax = false;
  @Input() url = "";
  @Input() sorting: boolean = true;
  @Input() pageSize;
  @Input() sortingSubscriber;
  @Input() selectable;
  @Input() hideSelectAll: boolean;
  @Input() hideFirstElement: boolean;

  sortStatus: Array<iSortStatus> = [];
  unsortedData;
  isAllSelected: boolean = false;

  ajaxDesc;
  ajaxAsc;

  constructor(private http: HttpClient) {

  }

  ngOnInit() {
    //data needs to be a flat object array, ex: [{date: 1/1/1, title: some title}]
    if (this.sortingSubscriber != undefined) {
      this.sortingSubscriber.subscribe((c) => {
        this.data = c;
        if (this.getState("head")) {
          this.initSort(this.getState("head"));
        }
      })
    }

    this.updateSortinStatuses(0);

  }

  setState(value, key = "sorting") {

    if (JSON.stringify(value)) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }

  getState(key) {
    let value = JSON.parse(localStorage.getItem(key));
    return value ?? null;
  }

  updateSortinStatuses(status, field = "") {

    if (field != "") {
      let f = field.toLocaleLowerCase();
      this.sortStatus.forEach((e, i) => {

        if (e.label == f) {
          this.sortStatus[i].status = status;
        } else {
          this.sortStatus[i].status = 0;
        }
      })

    } else {

      if (this.headers != undefined) {
        this.headers.map((e => {

          this.sortStatus.push({label: e.field.toLocaleLowerCase(), status: status});
        }))
      }
    }

  }

  selectAll() {
    this.isAllSelected = !this.isAllSelected;
    this.selectAllonPage.emit({selected: this.isAllSelected})

  }

  getCurrentSortStatus(field) {

    let status = null;
    let f = field.toLocaleLowerCase();

    if (this.getState("head")) {
      f = this.getState("head").field.toLocaleLowerCase();
    }

    this.sortStatus.map((e) => {
      if (f == e.label) {

        status = e.status;
      }
    })

    return status;
  }

  initSort(head) {
    //yes, its different than the other one.
    let status = this.getState("status");
    let field = head.field.toString();

    try {
      this.data.sort((a, b) => {

        switch (status) {
          case 0:

            this.updateSortinStatuses(0, head.field)
            if (Number.isInteger(a[head.field.toLowerCase()])) {
              return a[head.field.toLowerCase()] - b[head.field.toLowerCase()];
            }
            if (head.field.toLowerCase().includes("date")) {
              return (new Date(a[head.field]) as any) - (new Date(b[head.field]) as any)
            }

            return a[field].localeCompare(b[field]);

          case 1:

            this.updateSortinStatuses(2, head.field)
            if (Number.isInteger(a[head.field.toLowerCase()])) {
              return b[head.field.toLowerCase()] - a[head.field.toLowerCase()];
            }
            if (head.field.toLowerCase().includes("date")) {
              return (new Date(b[head.field]) as any) - (new Date(a[head.field]) as any)
            }
            return b[field].toString().localeCompare(a[field]);

          case 2:

            this.updateSortinStatuses(1, head.field)
            if (Number.isInteger(a[head.field.toLowerCase()])) {
              return a[head.field.toLowerCase()] - b[head.field.toLowerCase()];
            }
            if (head.field.toLowerCase().includes("date")) {
              return (new Date(a[head.field]) as any) - (new Date(b[head.field]) as any)
            }
            return a[field].localeCompare(b[field]);
        }

      });

    } catch (e) {
      //the filed does not exist in sorting local storage. Using default;
    }

    this.onChange.emit(this.data)
  }

  sortList(head) {

    this.setState(head, "head");

    if (this.sorting) {

      let status = this.getCurrentSortStatus(head.field);

      this.setState(status, "status");

      if (this.ajax) {

        switch (status) {

          case 0:
            this.updateSortinStatuses(1, head)
            this.ajaxSorting("desc", head)
            break;

          case 1:
            this.updateSortinStatuses(2, head)
            this.ajaxSorting("asc", head)
            break;

          case 2:
            this.updateSortinStatuses(0, head)
            this.ajaxSorting("", head)
            break;
        }

      } else {

        let field = head.field.toString();

        this.data.sort((a, b) => {

          switch (status) {
            case 0:

              this.updateSortinStatuses(1, head.field)
              if (Number.isInteger(a[head.field.toLowerCase()])) {
                return a[head.field.toLowerCase()] - b[head.field.toLowerCase()];
              }
              if (head.field.toLowerCase().includes("date")) {
                return (new Date(a[head.field]) as any) - (new Date(b[head.field]) as any)
              }

              return a[field].localeCompare(b[field]);

            case 1:

              this.updateSortinStatuses(2, head.field)
              if (Number.isInteger(a[head.field.toLowerCase()])) {
                return b[head.field.toLowerCase()] - a[head.field.toLowerCase()];
              }
              if (head.field.toLowerCase().includes("date")) {
                return (new Date(b[head.field]) as any) - (new Date(a[head.field]) as any)
              }
              return b[field].toString().localeCompare(a[field]);

            case 2:

              this.updateSortinStatuses(1, head.field)
              if (Number.isInteger(a[head.field.toLowerCase()])) {
                return a[head.field.toLowerCase()] - b[head.field.toLowerCase()];
              }
              if (head.field.toLowerCase().includes("date")) {
                return (new Date(a[head.field]) as any) - (new Date(b[head.field]) as any)
              }
              return a[field].localeCompare(b[field]);
          }

        });

        this.onChange.emit(this.data)

      }
    }

  }

  ajaxSorting(direction, head) {

    let sort = (direction != "") ? ("&sort=" + direction + "&sortKey=" + head) : "";
    let queryUrl = "?size=" + this.pageSize + "&offset=" + 0 + "&upper=" + this.pageSize + sort;

    this.http.get(this.url + queryUrl).subscribe((e) => {
      this.data = e["data"];
      this.onChange.emit(this.data)
    })
  }

  toggleSorting(event: any, index: number) {
    if (this.headers[index].options) {
      this.headers[index] = {
        headerName: event, field: event.toLowerCase(), sortable: true,
        options: [{headerName: this.headers[index].headerName, field: this.headers[index].headerName.field}]
      }
    }

    this.sortStatus[index].label = this.headers[index].field;
    this.updateSortinStatuses(0);
    this.sortList(this.headers[index]);
  }

  ngOnDestroy() {
    this.onChange = new EventEmitter();
  }
}
